import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Card, Box, Slide, useTheme, useMediaQuery, Typography } from "@mui/material";
import Loader from "../../Components/Loader/Loader";
import Error from "../../Components/Error/Error";
import { useDispatch, useSelector } from "react-redux";
import { fetchWallets } from "../../redux/state/walletsReduser/wallets.fetch";
import { selectIsLoading, selectWalletsError } from "../../redux/state/walletsReduser/wallets.selectors";
import PaymentButtons from "../../Components/PaymentButtons/PaymentButtons";
import ProductSlider from "../../Components/ProductsSlider/ProductsSlider";
import PaymentContent from "../../Components/PaymentContent/PaymentContent";


import { container, card, slide } from "./PaymentPage.styles";
import Captcha from "../../Components/Captcha/Captcha";

function PaymentPage() {
  const location = useLocation();
  const { product, variantId, district } = location.state || {};

  const dispatch = useDispatch();
  const [isExiting, setIsExiting] = useState(false);
  const [isCaptchaPassed, setIsCaptchaPassed] = useState(false); // Состояние капчи
  const isLoading = useSelector(selectIsLoading);
  const isError = useSelector(selectWalletsError);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    dispatch(fetchWallets());
  }, [dispatch]);

  useEffect(() => {
    if (isExiting) {
      setTimeout(() => {
        setIsExiting(false);
      }, 500);
    }
  }, [isExiting]);

  if (isLoading) return <Loader />;
  if (isError) return <Error message="Ошибка загрузки кошельков. Попробуйте позже." />;
  if (!product) return <Error message="Ошибка: товар не найден" />;

  const { name, img, price, nameCity } = product;
  const findVariantById = (product, variantId) =>
    product.variants.find((variant) => variant._id === variantId) || null;
  const { weight } = findVariantById(product, variantId) || {};

  const productLink = `/product/${product.artkl}`;

  return (
    <Box sx={container(isMobile)}>
      <Slide direction="right" in={!isExiting} timeout={500} sx={slide}>
        <Box sx={{ width: "100%", minHeight: "300px", display: "flex", flexDirection: "column", flexGrow: 1 }}>
          <Card sx={card(isMobile)}>
            <ProductSlider images={img} productLink={productLink} />
            <PaymentContent name={name} variantId={variantId} district={district} price={price} weight={weight} nameCity={nameCity} />
          </Card>
        </Box>
      </Slide>

      {/* Блок капчи */}
      {!isCaptchaPassed && (
        <Box sx={{ textAlign: "center", mt: 2 }}>
          <Typography variant="body1" color="textSecondary">
            Пройдите капчу, чтобы продолжить
          </Typography>
          <Captcha onSuccess={() => setIsCaptchaPassed(true)} />
        </Box>
      )}

      {/* Кнопки оплаты показываются только после прохождения капчи */}
      {isCaptchaPassed && (
        <PaymentButtons
          isExiting={isExiting}
          setIsExiting={setIsExiting}
          createOrderData={{ name, weight, district, price, nameCity }}
        />
      )}
    </Box>
  );
}

export default PaymentPage;